import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCircledRemove = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 12 12",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M6 12A6 6 0 106 0a6 6 0 000 12zm0-.923A5.077 5.077 0 116 .923a5.077 5.077 0 010 10.154zm1.366-7.25a.462.462 0 01.653.653L6.499 6l1.52 1.52a.462.462 0 01-.653.653l-1.52-1.52-1.52 1.52a.462.462 0 01-.58.059l-.072-.06a.462.462 0 010-.652L5.194 6l-1.52-1.52a.462.462 0 11.652-.653l1.52 1.52z",
		fill: "#FFF",
		fillRule: "evenodd",
		opacity: .502
	})
});
export default SvgCircledRemove;
